import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'textBaseStyle',
  'balanceBoosterAppliedStyle',
])

const sharedTextStyles = {
  lineHeight: 1,
  display: 'inline-block',
  fontWeight: 'semibold',
  fontSize: 'md',
  borderRadius: '3xs',
  px: '3xs',
  py: '2xs',
  border: 'var(--alto-sem-border-width-sm) solid var(--alto-sem-color-border-accent)',
}

export const PriceBreakdownCollectedAviosAmount = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({
    textBaseStyle: {
      ...sharedTextStyles,
      color: 'fg.accent.primary',
      bg: 'bg.base',
    },
    balanceBoosterAppliedStyle: {
      ...sharedTextStyles,
      bg: 'bg.accent.vibrant.active',
      color: 'fg.accent.onVibrant!important',
    },
  }),
})
